import React from 'react';

function App() {
  return (
    <div className="App min-h-screen bg-bg-dark flex items-center justify-center">
      <div className="text-center px-6">
        <h1 className="text-4xl font-heading font-bold text-text-light mb-4">
          Coming Soon
        </h1>
        <p className="text-text-dark text-lg mb-8">
          Something exciting is on the way. Check back shortly!
        </p>
        <p className="text-text-dark">
          Meanwhile, reach me at{' '}
          <a
            href="mailto:anilbalireddy7@gmail.com"
            className="text-primary hover:underline"
          >
            anilbalireddy7@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
}

/* MAINTENANCE MODE — to restore, replace App() above with the original:
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App min-h-screen bg-bg-dark">
      <Navbar />
      <Hero />
      <About />
      <Experience />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}
*/

export default App;


